import { render, staticRenderFns } from "./widget-rate.vue?vue&type=template&id=d4d3809c&scoped=true"
import script from "./widget-rate.vue?vue&type=script&lang=js"
export * from "./widget-rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d3809c",
  null
  
)

export default component.exports